module.exports = __webpack_public_path__ + "5992e87a4d56115d9695ceeb27c5a56b.svg";